// extracted by mini-css-extract-plugin
export default {"btn-wrapper":"FixMistakenWithdrawalPage_btn-wrapper__vMNo6","fix-withdrawal-wrapper":"FixMistakenWithdrawalPage_fix-withdrawal-wrapper__bWJdI"};